/**
 * Client-side validation for the add/edit video form. Returns a map of
 * field name to i18n key; an empty object means the form is valid. The
 * server validates again, so this only catches what we can check up front.
 */

/**
 * @param {string} value
 * @returns {boolean} true for absolute http(s) URLs with a host
 */
export function isHttpUrl(value) {
  try {
    const url = new URL(value);
    return (url.protocol === 'http:' || url.protocol === 'https:') && Boolean(url.hostname);
  } catch {
    return false;
  }
}

/**
 * @param {Object} values - form values
 * @param {{ mode: 'create'|'edit', youtubeVideoId?: string|null }} options
 * @returns {Object<string, string>}
 */
export default function validateVideoForm(values, options) {
  const { mode, youtubeVideoId = null } = options;
  const errors = {};

  if (mode === 'create') {
    if (!String(values.url ?? '').trim()) {
      errors.url = 'staff_videos.form.validation.url_required';
    } else if (!youtubeVideoId) {
      errors.url = 'staff_videos.form.validation.fetch_required';
    }
  }

  if (!String(values.title ?? '').trim()) {
    errors.title = 'staff_videos.form.validation.title_required';
  }

  const resourceUrl = String(values.resourceUrl ?? '').trim();
  if (resourceUrl && !isHttpUrl(resourceUrl)) {
    errors.resourceUrl = 'staff_videos.form.validation.resource_url_invalid';
  }

  return errors;
}
